// extracted by mini-css-extract-plugin
module.exports = {"cell":"RawDataTable_cell__2qwLB"};